import {ComplianceDocumentType} from '../constants/compliance-document-type';
import {ComplianceDocument} from './compliance-document';
import {AbstractModel} from './abstract-model';

export class AbstractDocumentsModel extends AbstractModel {

  id: number | null = null;
  documents: Record<ComplianceDocumentType, ComplianceDocument> = this.getRecords();

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.documents) {
      this.documents = this.getRecords();
      this.documents = input.documents.reduce((acc: Record<ComplianceDocumentType, ComplianceDocument>, document: any) => {
        const complianceDocument = new ComplianceDocument().deserialize(document);
        if (complianceDocument.type) {
          acc[complianceDocument.type] = complianceDocument;
        }
        return acc;
      }, this.documents);
    }

    return this;
  }

  private getRecords(): Record<ComplianceDocumentType, ComplianceDocument> {
    return {
      [ComplianceDocumentType.PROOF_OF_IDENTITY]: new ComplianceDocument(),
      [ComplianceDocumentType.CERTIFICATE_OF_INCORPORATION]: new ComplianceDocument(),
      [ComplianceDocumentType.SIGNED_CONTRACT]: new ComplianceDocument(),
      [ComplianceDocumentType.INSERTION_ORDER]: new ComplianceDocument(),
    };
  }
}
